/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'video': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4 2.25A1.75 1.75 0 002.25 4v16c0 .966.784 1.75 1.75 1.75h16A1.75 1.75 0 0021.75 20V4A1.75 1.75 0 0020 2.25H4zM3.75 4A.25.25 0 014 3.75h16a.25.25 0 01.25.25v16a.25.25 0 01-.25.25H4a.25.25 0 01-.25-.25V4zm9.789 8.08l-2.574 1.492v-2.976l2.574 1.484zm-2.574-3.216a1 1 0 00-1.5.867v4.71a1 1 0 001.502.864l4.072-2.361a1 1 0 00-.002-1.732l-4.072-2.348z" _fill="#000"/>'
  }
})
